import type { inferRouterOutputs } from '@trpc/server'
import type { AppRouter } from '../../../src/api/routers'
import { getPreferredWalletId } from './wallet-preference'

export type RouterOutputs = inferRouterOutputs<AppRouter>
export type Me = RouterOutputs['auth']['me']
export type MeWallet = Me['wallets'][number]
export type Portfolio = RouterOutputs['portfolio']['get']
/** a wallet token row; vault rows carry `custody: 'vault'` and otherwise look the same */
export type Holding = Portfolio['tokens'][number] & { custody?: 'vault'; platforms?: { platform: string; balance: string }[] }
export type VaultHolding = Portfolio['vault'][number]
export type VaultDepositView = RouterOutputs['vault']['deposit']
export type VaultWithdrawalView = RouterOutputs['vault']['withdrawal']
export type PrivateDepositView = RouterOutputs['privateDeposit']['get']
export type PrivateWithdrawalView = RouterOutputs['privateWithdrawal']['get']
export type StrategyView = RouterOutputs['strategy']['list'][number]
/** one finished trade as the P&L page sums it */
export type PnlSwap = RouterOutputs['swap']['pnlTrades'][number]
export type StrategyDetail = RouterOutputs['strategy']['get']
/** what a duplicate copies from a strategy (John, Nov 3 2026): its settings, never its progress; the detail and list rows both fit */
export type StrategyTemplate = Pick<StrategyView, 'id' | 'name' | 'kind' | 'side' | 'token' | 'settlement' | 'exchange' | 'dca' | 'limit' | 'limits' | 'execution'>
export type StrategyExecutionView = StrategyDetail['executions'][number]

export function primaryWallet(me: Me | null | undefined): MeWallet | null {
  if (!me || me.wallets.length === 0) return null
  const preferredId = getPreferredWalletId()
  const preferred = preferredId ? me.wallets.find((w) => w.id === preferredId && w.solanaAddress) : undefined
  if (preferred) return preferred
  const selected = me.wallets[me.selectedWalletIndex]
  const solana = me.wallets.find((w) => w.solanaAddress)
  return (selected?.solanaAddress ? selected : solana) ?? me.wallets[0]
}
export type PositionView = RouterOutputs['position']['get']
export type PositionListItem = RouterOutputs['position']['list'][number]
export type PositionSnapshot = Portfolio['positions'][number]
/** One line of a finished flow's fee receipt (label, amount, dollar value). */
export type FeeItem = NonNullable<PrivateDepositView['fees']>[number]
/** One hop of the route a swap took: venue, pair, share, what came out. */
export type RoutePath = NonNullable<PositionView['swaps'][number]['route']>[number]
